import { Validators as AngularValidators } from '@angular/forms';
import { maxValidator } from './max.validator';
import { minValidator } from './min.validator';
import { requiredValidator } from './required.validator';

export const Validators = {
    compose: AngularValidators.compose,
    composeAync: AngularValidators.composeAsync,
    max: maxValidator,
    min: minValidator,
    required: requiredValidator,
};
